module.exports = [{
      plugin: require('/tmp/2c789d6b/node_modules/gatsby-plugin-google-analytics/gatsby-browser.js'),
      options: {"plugins":[],"trackingId":"UA-48805584-3"},
    },{
      plugin: require('/tmp/2c789d6b/node_modules/gatsby-plugin-offline/gatsby-browser.js'),
      options: {"plugins":[]},
    },{
      plugin: require('/tmp/2c789d6b/node_modules/gatsby-plugin-typography/gatsby-browser.js'),
      options: {"plugins":[],"pathToConfigModule":"src/utils/typography"},
    },{
      plugin: require('/tmp/2c789d6b/gatsby-browser.js'),
      options: {"plugins":[]},
    }]
